import { useEffect, useState } from "react";
import "./hero.css";
import Navbar from "../navbar/Navbar";
import { FaArrowDown } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [dots, setDots] = useState([]);

  useEffect(() => {
    // Add animation after component mounts
    setTimeout(() => {
      setIsVisible(true);
    }, 300);

    // Generate random dots
    const newDots = [];
    for (let i = 0; i < 50; i++) {
      newDots.push({
        id: i,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 4}s`,
        duration: `${3 + Math.random() * 2}s`,
      });
    }
    setDots(newDots);
  }, []);

  const scrollToProjects = () => {
    const projectsSection = document.querySelector(".projects_container");
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="gradient-bg"></div>

        {/* Hexagon grid */}
        <div className="hexagon-grid"></div>

        {/* Geometric shapes */}
        <div className="geometric-container">
          <div className="geometric-shape shape-1"></div>
          <div className="geometric-shape shape-2"></div>
          <div className="geometric-shape shape-3"></div>
          <div className="geometric-shape shape-4"></div>
          <div className="geometric-shape shape-5"></div>
        </div>

        {/* Animated lines */}
        <div className="line-container">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>

        {/* Animated dots */}
        <div className="dots-container">
          {dots.map((dot) => (
            <div
              key={dot.id}
              className="dot"
              style={{
                top: dot.top,
                left: dot.left,
                animationDelay: dot.delay,
                animationDuration: dot.duration,
              }}
            ></div>
          ))}
        </div>

        {/* Code blocks */}
        <div className="code-block code-block-1">
          {
            "const Portfolio = () => {\n  return (\n    <div>Full Stack Developer</div>\n  );\n};"
          }
        </div>

        <div className="code-block code-block-2">
          {
            "function createProject() {\n  const skills = ['React', 'Node', 'CSS'];\n  return new Project(skills);\n}"
          }
        </div>

        <div className="code-block code-block-3">
          {
            "import { success } from 'career';\nexport const dedication = true;\nexport const creativity = 100;"
          }
        </div>
      </div>
      <Navbar />
      <div className="max-width hero-content">
        <div className={`hero-text-container ${isVisible ? "visible" : ""}`}>
          <span className="hero-greeting">Hi there, I'm</span>
          <h1 className="title hero_animation">Safi Nafi</h1>
          <h2 className="title second_title hero_animation">
            Full-Stack Web Developer
          </h2>
          <p className="hero-description">
            I build modern, responsive web applications with a focus on clean
            code and exceptional user experiences.
          </p>
          <div className="hero-buttons">
            <button
              onClick={() => {
                const fileId = "1pVbfsvF9l4ve3bb9aUJQKQHzKAE1UiX4";
                const url = `https://drive.google.com/uc?export=download&id=${fileId}`;

                const a = document.createElement("a");
                a.href = url;
                a.download = "download.pdf"; // Optional file name
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }}
              className="button primary-button hero_animation"
            >
              DOWNLOAD CV <MdOutlineFileDownload className="download-icon" />
            </button>
            <button
              onClick={scrollToProjects}
              className="button secondary-button hero_animation"
            >
              VIEW PROJECTS <FaArrowDown className="arrow-icon" />
            </button>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <div>
          <span className="scroll-arrow"></span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
